import { render } from "@/components/pages/individualWorkSupport/requirement081/Requirement081.html?vue&type=template&id=b704d53e&external"
import script from "@/components/pages/individualWorkSupport/requirement081/Requirement081.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement081/Requirement081.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__